const API_BASE_URL =
  process.env.REACT_APP_ENVSYNC_API_URL || "https://envsync-tqj1.onrender.com";

export default API_BASE_URL;
